import icon from '../../../assets/images/svg/viettel-media.svg';
import Campaign from './campaign';
import Method from './method';
import Products from './products';
import Order from './order';
import Ship from './ship';
import Bill from './bill';
import { connect } from 'react-redux';

const Infor = (props) => {
   const { carts } = props;

   return (
      <div className="layout-orders-livestream disabled layout-order-Confirm">
         <div className="header-shop-name"><span>Đơn hàng #{carts.sales_reference_code}</span></div>
         <div>
            <Campaign />
            <Products />
            <div className="end-page"></div>
            <Order />
            <div className="end-page"></div>
            <Ship />
            <div className="end-page"></div>
            <Method />
            <div className="end-page"></div>
         </div>
         <Bill />
         <div className="footer-power-vtm">
            <div className="copyright">
               <img src={icon} />
            </div>
         </div>
      </div>
   )
}
const mapStateToProps = (state) => {
   const { carts } = state;
   return {
      carts
   };
};

export default connect(mapStateToProps, {
})(Infor)
